import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DocumentStatus/All', method: 'GET', body: null, token: token })
}
